<template>
  <div  >
    <Header></Header>
    <Title title="考试统计"></Title>
    <div class="contain_main">
      <div class="search" @keydown.enter="changepage(1)">
        <div class="search_item">
          <div class="item">
            <span>考试:</span>
            <Input v-model="data.examtitle" placeholder="请输入..." style="width:2rem"/>
          </div>
          <div class="item">
            <span>考试状态:</span>
            <Select v-model="data.status" style="width:1rem">
              <Option value="all">全部</Option>
              <Option value="2">考试中</Option>
              <Option value="3">已结束</Option>
            </Select>
          </div>
          <div class="item">
            <div class="button" @click="changepage(1)">搜索</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <tr>
              <td>考试编号</td>
              <td>考试名称</td>
              <td>考试开始时间</td>
              <td>考试结束时间</td>
              <td>考试状态</td>
              <td>阅卷状态</td>
              <td>参考人数</td>
              <td>题目数</td>
              <td>平均分</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <td>{{item.examid}}</td>
              <td>
                <Tooltip :content="item.examtitle" placement="top-start">
                  <span class="tableName">{{item.examtitle}}</span>
                </Tooltip>
              </td>
              <td>{{item.examstartime|formatetime}}</td>
              <td>{{item.examendtime|formatetime}}</td>
              <td>{{item.examendtime|timedesc}}</td>
              <td>{{item.total==0?'无需阅卷':isdecide(item.less)}}</td>
              <td>{{item.total}}</td>
              <td>{{item.epcount}}</td>
              <td>{{item.score?Number(item.score).toFixed(2):item.score}}</td>
              <td>
                <button
                  class="orange"
                  @click="topage(item.examid,item.total,item.less,item.ehtype)"
                >统计分析</button>
                <button class="green" @click="$router.push('/recordslist?id='+item.examid)">考试记录</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page" style="text-align:right;margin-top:20px;">
        <Page
          :total="total"
          :current='data.page'
          @on-change="changepage"
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import { ExamStatistics_exam } from "../../assets/js/api.js";
export default {
  name: "testlist",
  data() {
    return {
      list: [],
      data: {
        examtitle: "", //	string	true	普通参数		考试标题
        status: "all", //	string	true	普通参数		1未开始2考试中3已结束
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      },
      total: null
    };
  },
  filters: {
    timedesc(value) {
      if (value) {
        var date = new Date();
        if (Number(value) > date.getTime() / 1000) {
          return "进行中";
        } else {
          return "已结束";
        }
      } else {
        return "进行中";
      }
    }
  },
  mounted() {
    this.getlist();
  },
  components: {
    Header,
    Title
  },
  methods: {
    isdecide(data) {
      if (data > 0) {
        return "阅卷中";
      } else {
        return "阅卷完成";
      }
    },
    changepage(data) {
      this.data.page = data;
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.getlist();
    },
    getlist() {
      var data = JSON.parse(JSON.stringify(this.data));
      if (this.data.status == "all") {
        data.status = " ";
      }
      ExamStatistics_exam(data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
          return
        }
        this.$Notice.warning({
          title: "信息提示",
          desc: res.data.message
        });
      });
    },
    topage(id, data, less, type) {
      if (type == 3) {
        this.$Notice.warning({
          title: "信息提示",
          desc: "随机试卷不开放统计！"
        });
        return;
      }
      if (data == 0) {
        this.$Notice.warning({
          title: "信息提示",
          desc: "参考人数为零，无法统计！"
        });
        return;
      }
      if (less > 0) {
        this.$Notice.warning({
          title: "信息提示",
          desc: "请阅卷完成后查看统计！"
        });
        return;
      }
      this.$router.push("/anaslyse?id=" + id);
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  border-radius: 0.2rem;
  border: none;
  margin: 0 0.02rem;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
button.blue {
  color: #25b3f9;
  background: #d3f3fc;
}
button.pri {
  color: #e037ff;
  background: #fadfff;
}
button.orange {
  color: #ff8d13;
  background: #ffe2c4;
}
button.green {
  color: #36cd68;
  background: #cffade;
}
button.red {
  color: #ff3a68;
  background: #ffd6de;
}
</style>


// WEBPACK FOOTER //
// src/pages/statistics/testsrecord.vue